// extracted by mini-css-extract-plugin
export default {"controls":"ProjectsNavigator_controls__prvou","buttons":"ProjectsNavigator_buttons__6nlrS","btn":"ProjectsNavigator_btn__N9+b7"};